if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      // Only operate if a real product form exists inside this component
      // (your recommendations should render a real {%- form 'product' -%} with inputs)
      this.form = this.querySelector('form');
      if (!this.form) return;

      // Must have a variant id input for add-to-cart to work
      const idInput = this.form.querySelector('[name="id"]');
      if (!idInput) return;
      idInput.disabled = false;

      // Button and cart targets are optional in some contexts (recommendations, quick add)
      this.submitButton = this.querySelector('[type="submit"]') || this.form.querySelector('[type="submit"]') || null;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || null;

      // If there is a cart drawer, expose dialog semantics
      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      // Bind once
      this.onSubmitHandler = this.onSubmitHandler.bind(this);

      // Hook submit
      this.form.addEventListener('submit', this.onSubmitHandler);
    }

    // For dynamic mounts (optional hook if you re-render forms via AJAX)
    initMoreForms() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name="id"]');
      if (!idInput) return;
      idInput.disabled = false;

      this.submitButton = this.querySelector('[type="submit"]') || this.form.querySelector('[type="submit"]') || null;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || null;

      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.form.addEventListener('submit', this.onSubmitHandler);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // Guards so we never throw on templates without full UI
      if (!this.form) return;

      if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }
      this.querySelector('.loading-overlay__spinner')?.classList?.remove('hidden');

      // Build fetch config; assumes global fetchConfig from theme
      const config = fetchConfig ? fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json' } };
      if (config.headers) delete config.headers['Accepts'];

      const idEl = this.form.querySelector('input[name="id"]');
      const qtyEl = this.form.querySelector('input[name="quantity"]');
      const id = parseInt(idEl?.value, 10);
      const qty = parseInt(qtyEl?.value, 10) || 1;

      // If we somehow lack id, bail gracefully (don’t error on email-for-price)
      if (!Number.isFinite(id)) {
        this.finish(false);
        return;
      }

      const sections = this.cart?.getSectionsToRender?.().map(s => s.id).join() || '';
      const body = {
        sections,
        sections_url: window.location.pathname,
        items: [{
          id,
          quantity: qty,
          properties: {
            'Product Type': this.submitButton?.dataset?.productType,
            'Shipping Type': this.submitButton?.dataset?.shippingType
          }
        }]
      };

      if (this.dataset.cartType != 'page') {
        this.cart?.setActiveElement?.(document.activeElement);
      }

      config.body = JSON.stringify(body);

      fetch(`${routes.cart_add_url}.js`, config)
        .then(r => r.json())
        .then(response => {
          if (response?.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (soldOutMessage && this.submitButton) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList?.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }
          if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart?.renderContents?.(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart?.renderContents?.(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.finish(!this.error);
        });
    }

    finish(enableButton) {
      this.submitButton?.classList?.remove('loading');
      if (this.cart?.classList?.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (enableButton) this.submitButton?.removeAttribute?.('aria-disabled');
      this.querySelector('.loading-overlay__spinner')?.classList?.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}
